import * as React from "react"
import { Link } from 'gatsby-plugin-modal-routing-3'
import './styles/index.scss';

import Layout from "../layout/layout"
import Seo from "../layout/seo"
import FeaturedSpeakers from "../components/featuredSpeakers"
import imgHeroLogo from "../images/img-hero-logo.svg"

const IndexPage = () => (
  <Layout innerPage={false}>
    <Seo title="Ignite Summit November 9-10, 2022 - Call for Speakers is now open!" description="Share your Ignite experience with the Apache Ignite community that is based in the UK, Europe, and Asia! We are seeking technical content from in-memory computing practitioners: deployment stories, technical deep dives, best practices, and integrations. Submit your proposal before September 15, 2022" />
      <section className="homeHeader" >
        <div className="bgWrapper">
          <div className="container " >
            <div className="top" >
              <img src={imgHeroLogo} width={`543px`} height={`168px`} />
              <div className="content">
                <h1><span className="turquoise">JUNE 14</span> VIRTUAL EVENT</h1>
                <p>All of the Ignite Summit 2022 sessions from June 2022 are now available to watch on-demand. See all fourteen developer presentations covering a range of topics. You'll learn ways to improve your deployments today, and how to prepare for the upcoming enhancements in Ignite 3.</p>
                <div className="buttons">
                  <Link
                    to="https://www.youtube.com/playlist?list=PLMc7NR20hA-KqL1RCbsK1brtDGWzbvjyL"
                    className="speaker button active"
                  >
                    Watch now <span>→</span>
                  </Link>
                </div>
              </div>
            </div>
        </div>
      </div>
    </section>

    <FeaturedSpeakers />

    <div className="schedule-buttons">
      <Link
        to="/schedule"
      >
        Check out the full schedule <span>→</span>
      </Link>
    </div>
  
  </Layout>
)

export default IndexPage
